const MIME_BY_EXTENSION: Record<string, string> = {
  csv: "text/csv",
  zip: "application/zip",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
};

const getExtension = (fileName: string): string => {
  const lastDot = fileName.lastIndexOf(".");
  return lastDot >= 0 ? fileName.slice(lastDot).toLowerCase() : "";
};

const resolveMimeType = (fileName: string, mimeType?: string): string | undefined => {
  if (mimeType) {
    return mimeType.split(";")[0];
  }
  const ext = getExtension(fileName).replace(".", "");
  return MIME_BY_EXTENSION[ext];
};

const downloadViaAnchor = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  document.body.appendChild(anchor);
  anchor.style.display = "none";
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(url), 100);
};

const saveViaPicker = async (blob: Blob, fileName: string, mimeType?: string): Promise<void> => {
  const resolvedMime = resolveMimeType(fileName, mimeType);
  const extension = getExtension(fileName);

  const handle = await window.showSaveFilePicker!({
    suggestedName: fileName,
    ...(resolvedMime && extension
      ? {
          types: [
            {
              description: fileName,
              accept: { [resolvedMime]: [extension] },
            },
          ],
        }
      : {}),
  });

  const writable = await handle.createWritable();
  try {
    await writable.write(blob);
  } finally {
    await writable.close();
  }
};

export const saveBlob = async (blob: Blob, fileName: string, mimeType?: string): Promise<boolean> => {
  if (typeof window.showSaveFilePicker === "function") {
    try {
      await saveViaPicker(blob, fileName, mimeType);
      return true;
    } catch (error) {
      if (error instanceof DOMException && error.name === "AbortError") {
        return false;
      }
    }
  }

  downloadViaAnchor(blob, fileName);
  return true;
};

export const saveDataUrl = async (dataUrl: string, fileName: string): Promise<boolean> => {
  const response = await fetch(dataUrl);
  const blob = await response.blob();
  return saveBlob(blob, fileName, blob.type || undefined);
};
